exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PostpaidInvoices_sumWrapper_2w1s {\n  white-space: nowrap;\n  text-align: right;\n}\n\n.PostpaidInvoices_sumPercentageWrapper_2Ei8 {\n  margin-left: 5px;\n\n  display: inline-block;\n  vertical-align: middle;\n\n  width: 100px;\n}\n\n.PostpaidInvoices_sumPercentage_1gHO {\n  height: 12px;\n\n  background-color: #38a8d6;\n}\n\n.PostpaidInvoices_tabs_3QwM {\n  margin-bottom: 10px;\n\n  text-align: left;\n}\n\n.PostpaidInvoices_total_26B2 {\n  margin-top: 10px;\n\n  display: -webkit-box;\n\n  display: -webkit-flex;\n\n  display: -ms-flexbox;\n\n  display: flex;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n\n  max-width: 500px;\n\n  font-size: 20px;\n}\n", ""]);

// exports
exports.locals = {
	"sumWrapper": "PostpaidInvoices_sumWrapper_2w1s",
	"sumPercentageWrapper": "PostpaidInvoices_sumPercentageWrapper_2Ei8",
	"sumPercentage": "PostpaidInvoices_sumPercentage_1gHO",
	"tabs": "PostpaidInvoices_tabs_3QwM",
	"total": "PostpaidInvoices_total_26B2"
};